export const mapPaginationResponse = (pagination) => {
  return {
    currentPage: pagination.current_page,
    totalPages: pagination.total_pages,
    totalCount: pagination.total_count
  };
};
